import { render, staticRenderFns } from "./sms_management.vue?vue&type=template&id=737bc32e&scoped=true"
import script from "./sms_management.vue?vue&type=script&lang=js"
export * from "./sms_management.vue?vue&type=script&lang=js"
import style0 from "./sms_management.vue?vue&type=style&index=0&id=737bc32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737bc32e",
  null
  
)

export default component.exports